import { PayPalError } from '../../../../typings'
import {
  COVER_IMAGE_UPLOAD_ERRORS,
  UNALLOWED_ENCODED_IMAGE_TYPES,
} from '../../constants'
import { base64ToHex, normalizeImage } from './image-input-utils'

interface ImageFileReader {
  restrictedTotalSize?: number
  files: any[]
  pixelCrop?: any
}

interface ImageBlob extends Blob {
  name: string
}

export const readAsDataURLAsync = async (file: ImageBlob) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = function () {
      return resolve({
        data: fileReader.result,
        name: file.name,
        size: file.size,
        type: file.type,
      })
    }
    fileReader.onerror = function (err) {
      return reject(err)
    }
    fileReader.readAsDataURL(file)
  })
}

export const imageFileReader = async ({
  files,
  restrictedTotalSize,
  pixelCrop,
}: ImageFileReader): Promise<{ url: string; name: string }> => {
  const file: ImageBlob = files[0]

  const fileReadData: any = await readAsDataURLAsync(file)
  const url: string = fileReadData.data as string

  // Get file signature from magic bytes
  const magicNumber = url.split('base64,')[1].slice(0, 6)
  const fileSignature = base64ToHex(magicNumber)

  // Look for specific disallowed file types using file signature
  if (UNALLOWED_ENCODED_IMAGE_TYPES.includes(fileSignature)) {
    const error: PayPalError = new Error('Invalid file type')
    error.code = COVER_IMAGE_UPLOAD_ERRORS.FILE_INVALID_TYPE
    throw error
  }

  const options = {
    mimeType: file.type,
    normalizeImageSize: false,
    pixelCrop,
  }

  if (restrictedTotalSize) {
    const restrictedSize = restrictedTotalSize
    const normalizedUrl = await normalizeImage(
      url,
      restrictedSize,
      restrictedSize,
      { ...options, normalizeImageSize: true },
    )
    return {
      url: normalizedUrl,
      name: file && file.name,
    }
  }
  const normalizedUrl = await normalizeImage(url, null, null, options)
  return { url: normalizedUrl, name: file && file.name }
}
